import React from 'react';
import { Zap } from 'lucide-react';

interface TeamMemberBadgeProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const TeamMemberBadge: React.FC<TeamMemberBadgeProps> = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1.5',
    lg: 'text-base px-4 py-2'
  };

  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5'
  };

  return (
    <div 
      className={`
        inline-flex items-center gap-1.5 
        bg-gradient-to-r from-yellow-400 to-amber-500 
        text-black font-semibold rounded-md
        shadow-lg shadow-yellow-500/30
        ${sizeClasses[size]}
        ${className}
      `}
    >
      <Zap className={`${iconSizes[size]} fill-black`} />
      <span>ÉQUIPE FIRST TUESDAY</span>
    </div>
  );
};
